<template>
  <div>
    <div class="evaluation-container">
      <div>
        <button
          v-if="getRights($entitiesName.Evaluation.Safety).create"
          style="margin-bottom: 20px"
          class="button is-success is-pulled-right is-small m-l-20"
          @click.stop="$refs.addEvaluationModal.open()"
          @click="setEvaluationType('safety')"
        >
          <i class="fa fa-plus"></i>
          &nbsp;{{ $t("evaluation.safetyTitle") }}
        </button>
        <button
          v-if="getRights($entitiesName.Evaluation.Procurement).create"
          class="button is-success is-pulled-right is-small"
          @click.stop="$refs.addEvaluationModal.open()"
          @click="setEvaluationType('procurement')"
        >
          <i class="fa fa-plus"></i>
          &nbsp;{{ $t("evaluation.procurementTitle") }}
        </button>
      </div>
    </div>
    <datatable
      :fetch="fetchEvaluationPerAgency"
      key="agencyEvaluation"
      ref="agencyEvaluation"
      objectName="agencyEvaluation"
      :enableDownload="false"
      :size="10"
      :noSelection="true"
      :isSmall="true"
      :reversePagination="true"
      :singleSelect="true"
      :filterColumns="false"
      :paginateOptions="[10, 20, 50]"
    >
      <div
        slot="type"
        slot-scope="{ item }"
        :title="$t('evaluation.type')"
        :sortable="true"
      >
        {{ getTypeTranslation(item.type) }}
      </div>
      <div
        slot="value"
        slot-scope="{ item }"
        :title="$t('evaluation.rating')"
        :sortable="true"
      >
        {{ item.value }}
      </div>
      <div
        slot="comment"
        slot-scope="{ item }"
        :title="$t('evaluation.comment')"
        :sortable="true"
      >
        {{ item.comment }}
      </div>
      <div
        slot="document"
        slot-scope="{ item }"
        :title="$t('evaluation.document')"
        :sortable="true"
      >
        <div class="document-container">
          <i
            v-if="item.documents && item.documents.length > 0"
            class="fa fa-cloud-download"
            @mouseenter="showPopup(item.id)"
            @mouseleave="hidePopup(item.id)"
            @click="downloadAllDocuments(item.documents)"
          ></i>

          <div v-if="isPopupVisible(item.id)" class="filename-popup">
            <ul>
              <li v-for="(doc, index) in item.documents" :key="index">
                {{ doc.filename }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div slot="actions" slot-scope="{ item }">
        <button
          v-if="
            (getRights($entitiesName.Evaluation.Safety).delete &&
              item.type === 1) ||
            (getRights($entitiesName.Evaluation.Procurement).delete &&
              item.type === 2) ||
            (getRights($entitiesName.Evaluation.Project).delete &&
              item.type === 3)
          "
          :class="{ 'is-loading': deletingEvaluation === item.id }"
          class="button is-danger is-small"
        >
          <i @click="deleteEvaluation(item.id)" class="fa fa-trash"></i>
        </button>
      </div>
    </datatable>
    <modal
      @create="addEvaluation"
      ref="addEvaluationModal"
      :title="$t(`evaluation.${this.evaluationType}Title`)"
      :loading="isUploading"
    >
      <div class="columns">
        <div class="column" style="height: 650px">
          <p class="rating-helper">
            {{ $t("evaluation.helper.intro") }}
          </p>
          <template v-if="evaluationType === 'safety'">
            <star-rating
              class="m-t-15 comment-evaluation"
              :label="$t('evaluation.safety.label')"
              :subLabel="[
                $t('evaluation.safety.rules'),
                $t('evaluation.safety.regulations'),
              ]"
              :number-of-stars="5"
              @rating-selected="handleRatingSafety"
            ></star-rating>
          </template>

          <template v-if="evaluationType === 'procurement'">
            <star-rating
              class="m-t-15 comment-evaluation"
              :label="$t('evaluation.rse.label')"
              :subLabel="[
                $t('evaluation.rse.environment'),
                $t('evaluation.rse.waste'),
                $t('evaluation.rse.impact'),
                $t('evaluation.rse.packaging'),
                $t('evaluation.rse.transparency'),
                $t('evaluation.rse.ethics'),
                $t('evaluation.rse.standards'),
                $t('evaluation.rse.performance'),
                $t('evaluation.rse.insertion'),
              ]"
              :number-of-stars="5"
              @rating-selected="handleRatingRSE"
            ></star-rating>

            <star-rating
              class="m-t-15 comment-evaluation"
              :label="$t('evaluation.relational.label')"
              :subLabel="[
                $t('evaluation.relational.quality'),
                $t('evaluation.relational.communication'),
                $t('evaluation.relational.responses'),
                $t('evaluation.relational.procedure'),
                $t('evaluation.relational.billing'),
                $t('evaluation.relational.disputes'),
                $t('evaluation.relational.attendance'),
                $t('evaluation.relational.commercial'),
                $t('evaluation.relational.payment'),
              ]"
              :number-of-stars="5"
              @rating-selected="handleRatingRelational"
            ></star-rating>
          </template>

          <div class="comment-evaluation">
            <label class="label">{{ $t("evaluation.comment") }}</label>
            <textarea
              class="textarea"
              v-model="evaluation.comment"
              rows="4"
            ></textarea>
          </div>

          <div class="multi-upload-container comment-evaluation">
            <div class="document-label m-b-15">Documents</div>
            <vue-dropzone
              ref="vueDropzone"
              :options="dropzoneOptions"
              @vdropzone-file-added="handleFileAdded"
              @vdropzone-file-removed="handleFileRemoved"
              id="customdropzone"
              :include-styling="false"
              :useCustomSlot="true"
            >
              <div class="default-message" v-if="selectedFiles.length === 0">
                <i class="fa fa-cloud-upload"></i>Déposer ou faire glisser
              </div>
            </vue-dropzone>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import VueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapGetters } from "vuex";

export default {
  name: "evaluation-agency",
  components: {
    VueDropzone,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    const dictRemoveFileText =
      "<i style='margin-top: -25px; margin-left: -35px' class='delete is-pulled-left is-medium'></i>";
    return {
      evaluation: {
        safety: 0,
        rse: 0,
        relational: 0,
        comment: "",
      },
      API: axios.defaults.baseURL,
      authToken: this.$store.getters["auth/getToken"],
      evaluationType: "procurement",
      selectedFiles: [],
      dropzoneOptions: {
        autoProcessQueue: false,
        url: "http://localhost",
        maxFilesize: 2,
        addRemoveLinks: true,
        dictRemoveFile: dictRemoveFileText,
        dictDefaultMessage: "",
        previewTemplate: this.template(),

        removedfile: (file) => {
          this.handleFileRemoved(file);
        },
      },

      createDocument: {
        documentType: "evaluation",
        file: null,
      },
      visiblePopups: {},
      isUploading: false,
      deletingEvaluation: null,
    };
  },
  computed: {
    ...mapGetters({
      getRights: "auth/getRights",
      userRoleOptions: "auth/getOptions",
    }),
  },
  methods: {
    template() {
      return `<div style='position: relative; width: fit-content; margin-bottom: 15px; text-wrap: nowrap; margin-left: 25px' class="dz-preview dz-file-preview">
                <div class="dz-details">
                  <div class="dz-filename"><span data-dz-name></span></div>
                </div>
                <div class="dz-error-message">
                  <span data-dz-errormessage></span>
                </div>
              </div>`;
    },

    addEvaluation() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isUploading = true;

          const evaluationData = {
            comment: this.evaluation.comment,
          };

          if (this.evaluationType === "safety") {
            evaluationData.safety = this.evaluation.safety;
          } else if (this.evaluationType === "procurement") {
            evaluationData.rse = this.evaluation.rse;
            evaluationData.relational = this.evaluation.relational;
          }

          axios
            .post(
              `/evaluation/${this.evaluationType}/${this.id}`,
              evaluationData
            )
            .then((response) => {
              if (this.selectedFiles.length > 0) {
                return this.uploadFiles(response.data.id);
              }
            })
            .finally(() => {
              this.isUploading = false;
              this.evaluation.safety = 0;
              this.evaluation.rse = 0;
              this.evaluation.relational = 0;
              this.evaluation.comment = "";
              this.selectedFiles = [];
              this.$refs.vueDropzone.removeAllFiles();
              this.$refs.addEvaluationModal.close();
              this.$refs.agencyEvaluation.refresh();
            });
        }
      });
    },
    handleRatingSafety(rating) {
      this.evaluation.safety = rating;
    },
    handleRatingRSE(rating) {
      this.evaluation.rse = rating;
    },
    handleRatingRelational(rating) {
      this.evaluation.relational = rating;
    },
    setEvaluationType(params) {
      this.evaluationType = params;
    },
    fetchEvaluationPerAgency(p) {
      return this.$api.fetchEvaluationPerAgency(p, this.id);
    },
    getTypeTranslation(type) {
      switch (type) {
        case 1:
          return this.$t("evaluation.safety.label");
        case 2:
          return this.$t("evaluation.procurement");
        case 3:
          return this.$t("evaluation.project");
        default:
          return "";
      }
    },

    handleFileAdded(file) {
      this.selectedFiles.push(file);
      this.$nextTick(() => {
        const dzMessage =
          this.$refs.vueDropzone.$el.querySelector(".dz-message");
        if (dzMessage) {
          dzMessage.remove();
        }
      });
    },

    handleFileRemoved(file) {
      this.selectedFiles = this.selectedFiles.filter(
        (selectedFile) =>
          selectedFile.name !== file.name || selectedFile.size !== file.size
      );

      if (file.previewElement) {
        file.previewElement.remove();
      }
    },

    uploadFiles(evaluationId) {
      const uploadPromises = this.selectedFiles.map((file) => {
        this.createDocument.file = file;

        const form = new FormData();
        form.set(
          "file",
          this.createDocument.file,
          this.createDocument.file.name
        );
        form.set("entity", "evaluation");
        form.set("id", evaluationId);
        form.set("type", 11);

        return axios.post("/document", form);
      });

      return Promise.all(uploadPromises)
        .then(() => {
          this.$refs.agencyEvaluation.refresh();
        })
        .catch((error) => {
          console.error("Error uploading documents:", error);
        });
    },
    showPopup(itemId) {
      this.$set(this.visiblePopups, itemId, true);
    },
    hidePopup(itemId) {
      this.$set(this.visiblePopups, itemId, false);
    },
    isPopupVisible(itemId) {
      return !!this.visiblePopups[itemId];
    },

    async downloadAllDocuments(documents) {
      for (const doc of documents) {
        await this.downloadDocument(doc);
      }
    },
    async downloadDocument(doc) {
      try {
        const response = await axios({
          url: `/document/${doc.id}`,
          method: "POST",
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${this.authToken}`,
          },
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", doc.filename);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          link.remove();
        }, 100);
      } catch (error) {
        console.error(`Error downloading document ${doc.id}:`, error);
      }
    },

    deleteEvaluation(id) {
      this.$awn.confirm(this.$t("evaluation.deleteEvaluation"), () => {
        this.deletingEvaluation = id;
        axios
          .delete(`/evaluation/${id}`)
          .then(() => {
            this.$refs.agencyEvaluation.refresh();
          })
          .finally(() => {
            this.deletingEvaluation = null;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.m-l-20 {
  margin-left: 20px;
}
.m-t-15 {
  margin-top: 15px;
}

.m-b-15 {
  margin-bottom: 15px;
}

.min-width-100 {
  width: 100%;
  :deep(textarea) {
    min-width: 100% !important;
    width: 100% !important;
  }
}

.multi-upload-container {
  width: 100%;
}

.document-label {
  font-weight: bold;
  vertical-align: top;
  padding-right: 4px;
}

#customdropzone {
  background-color: white;
  font-family: "Arial", sans-serif;
  letter-spacing: 0.2px;
  color: #777;
  transition: background-color 0.2s linear;
  height: auto;
  padding: 40px;
  margin-top: 5px;
  border-style: dashed;
  border-color: #019fc4;
}

#customdropzone:hover {
  background-color: #f6f6f6;
}

.default-message {
  cursor: pointer;
  text-align: center;
  margin: 2em 0;
  letter-spacing: 0.2px;
  color: #777;
}

.document-container {
  position: relative;
  display: inline-block;
}

.filename-popup {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  border-radius: 5px;
}

.filename-popup::before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: white transparent transparent transparent;
}

.filename-popup ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.filename-popup li {
  margin-bottom: 5px;
}

.filename-popup li:last-child {
  margin-bottom: 0;
}

.comment-evaluation {
  margin-bottom: 35px;
  padding: 20px;
  border-radius: 8px;
  background-color: #f8f9fa;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  width: 100%;
  box-sizing: border-box;
}

.label {
  font-weight: bold;
  margin-bottom: 10px;
  display: block;
}

.textarea {
  width: 100%;
  min-width: 100%;
  padding: 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 0.95rem;
  resize: vertical;
  min-height: 100px;
  box-sizing: border-box;
  margin-bottom: 15px;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.1);
  }
}
</style>
